import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import BaseBadge from 'admin/components/shared/BaseBadge';
import styles from './styles.scss';

const MaintenanceBadgeList = (kioskMaintenance) => {

  const renderBadgeIfMaintained = (maintained, label) => {
    if (maintained) {
      return <BaseBadge className="badge">{label}</BaseBadge>;
    }
    return null;
  };

  const viewMaintenanceList = (maintenance) => {
    const {
      cash_collect,
      coin_jam,
      printer_roll,
      cleaning,
      other,
    } = maintenance;
    return (
      <span>
        { renderBadgeIfMaintained(cash_collect, '現金回収') }
        { renderBadgeIfMaintained(coin_jam, 'コイン詰まり解消') }
        { renderBadgeIfMaintained(printer_roll, 'レシート用紙交換') }
        { renderBadgeIfMaintained(cleaning, '清掃') }
        { renderBadgeIfMaintained(other, 'その他') }
      </span>
    );
  };

  return (
    viewMaintenanceList(kioskMaintenance.kioskMaintenance)
  );
};

MaintenanceBadgeList.propTypes = {
  kioskMaintenance: PropTypes.object,
};

MaintenanceBadgeList.defaultProps = {
  kioskMaintenance: {},
};

export default CSSModules(MaintenanceBadgeList, styles, { allowMultiple: true });
